import { FC } from 'react'
import styled from 'styled-components'
import HelperTextWithIcon from '../HelperTextWithIcon'

const OpenGraphPreviewError: FC = () => {
  return (
    <StyledWrapper>
      <HelperTextWithIcon
        color="error"
        text="미리보기를 표시할 수 없습니다. 미리보기 없이 올리시거나 다른링크를 이용하세요."
      />
    </StyledWrapper>
  )
}

export default OpenGraphPreviewError

const StyledWrapper = styled.div`
  padding: 20px;
  background-color: #f5fafd;
`
